<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="pa-2 rounded elevation-1 bg-white">
                        <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
                            variant="outlined">
                            <v-icon left>mdi-arrow-left</v-icon>
                            Retour
                        </v-btn>
                        <div class="text-h6 mt-2 mb-3">Envoi du mail de rappel de contact SMS à tous les inscrits ayant
                            souscrit à l'alerte SMS {{ mainStore.module.nom }}</div>
                        <div v-if="previous_sends">
                            <v-alert v-for="send in previous_sends" :key="send.id" class="mb-2" border="start"
                                border-color="red" elevation="0">
                                Un envoi a déja été effectué le {{ $moment(send.timestamp).format("DD/MM/YYYY à HH:mm") }} par {{ send.owner }}
                            </v-alert>
                        </div>
                        <div class="mb-3">
                            <v-btn color="primary-dark" @click="sendBulkEmails()" prepend-icon="mdi-send" variant="flat"
                                :loading="in_progress">Lancer l'envoi aux {{ inscrits.length }}
                                inscrits</v-btn>
                        </div>

                        <div class="d-flex sm-gap">
                            <v-chip v-if="in_progress" color="primary-dark" variant="flat" class="text-white"
                                density="compact">Envoi
                                en
                                cours...</v-chip>
                            <v-chip color="darkblue" variant="flat" class="text-white" density="compact">{{
                                inscrits.length }}
                                Inscrits</v-chip>
                            <v-chip color="green-darken-4" variant="flat" class="text-white" density="compact">{{
                                success }} emails
                                envoyés</v-chip>
                            <v-chip color="red-darken-4" variant="flat" class="text-white" density="compact">{{ fail }}
                                echecs</v-chip>
                        </div>

                        <v-list density="compact">
                            <v-list-item v-for="(inscrit, i) in inscrits" :key="i" :value="inscrit" color="primary">
                                <template v-slot:prepend>
                                    <v-icon icon="mdi-send-clock" v-if="!inscrit.send" color="primary-dark"
                                        size="large"></v-icon>
                                    <v-icon icon="mdi-send-check" color="green-darken-4"
                                        v-if="inscrit.send && inscrit.success"></v-icon>
                                    <v-icon icon="mdi-alert-circle" color="red-darken-4"
                                        v-if="inscrit.send && !inscrit.success"></v-icon>
                                </template>

                                <v-list-item-title>
                                    {{ inscrit.nom }} {{ inscrit.prenom }}
                                    <span v-if="inscrit.dossard != '0'">[Doss. {{ inscrit.dossard }}]</span>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";

export default {
    components: {},
    data() {
        return {
            inscrits: [],
            previous_sends: null,
            launched: false,
            success: 0,
            fail: 0,
            in_progress: false,
        };
    },
    computed: {
        ...mapStores(useMainStore),
    },

    methods: {
        async sendBulkEmails() {
            AdminService.writeLogs("envoi_rappel_contact_sms", this.mainStore.module.id, this.mainStore.authAdmin.getUsername);
            this.launched = true;
            this.in_progress = true;
            for (let i = 0; i < this.inscrits.length; i++) {
                let request = await AdminService.sendRappelContactSMS(this.inscrits[i].id);
                if (request) {
                    this.success++;
                    this.inscrits[i].send = true;
                    this.inscrits[i].success = true;
                }
                else {
                    this.fail++;
                    this.inscrits[i].send = true;
                    this.inscrits[i].success = false;
                }
            }
            this.in_progress = false;
        },
        async loadInscrits() {
            let request = await AdminService.getLightInscriptionsAlerteSMS(this.mainStore.module.id);
            if (request) {
                this.inscrits = request;
            }
        },
        async fetchLogs() {
            let request = await AdminService.getLogs("envoi_rappel_contact_sms", this.mainStore.module.id);
            if (request) {
                this.previous_sends = request;
            }
        }
    },
    async created() {
        await this.fetchLogs();
        await this.loadInscrits();
    },
};
</script>

<style lang="scss" scoped>
.send_failed {
    background-color: #ff00001a;
}
</style>
